module.exports = __webpack_public_path__ + "img/ar-tab1.e0b2cdad.jpg";